// filepath: apps/web/src/features/admin/secrets/PendingReviewBanner.tsx
//
// FR-UI-ADM-10 AC-7 -- pending-promotion-review banner for the
// secret reference editor. Mirrors the FR-UI-ADM-6 webhook pattern
// and the FR-UI-ADM-1 permission matrix pattern; scoped to
// def_type=secret_ref.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

interface PendingReviewBannerProps {
  pendingCount: number | null;
  onOpenPromotion: () => void;
}

export function PendingReviewBanner({
  pendingCount,
  onOpenPromotion,
}: PendingReviewBannerProps): React.ReactElement | null {
  const { t } = useTranslation();
  if (pendingCount === null || pendingCount <= 0) return null;
  return (
    <div
      className="rounded border border-yellow-300 bg-yellow-50 px-3 py-2 text-sm text-yellow-900"
      role="status"
      data-testid="pending-review-banner"
    >
      <span>
        {t("admin.secrets.banner.pending_review")} ({pendingCount})
      </span>
      <button
        type="button"
        className="ml-3 rounded border border-yellow-400 px-2 py-1 text-xs font-medium hover:bg-yellow-100"
        onClick={onOpenPromotion}
        data-testid="pending-review-open"
      >
        {t("admin.secrets.banner.open_review")}
      </button>
    </div>
  );
}
